import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import './styles/index.css';

const syncViewportBottomOffset = () => {
  const visualViewport = window.visualViewport;
  if (!visualViewport) return;

  const layoutHeight = document.documentElement.clientHeight;
  const offset = Math.max(0, layoutHeight - visualViewport.height - visualViewport.offsetTop);
  document.documentElement.style.setProperty('--viewport-bottom-offset', `${Math.round(offset)}px`);
};

syncViewportBottomOffset();
window.addEventListener('resize', syncViewportBottomOffset);
window.visualViewport?.addEventListener('resize', syncViewportBottomOffset);
window.visualViewport?.addEventListener('scroll', syncViewportBottomOffset);

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(i18n);

app.mount('#app');
